import { useEffect } from "react"

import { FEATURE_FLAGS_CONFIG } from "../config/featureFlags.config"
import { useAppDispatch } from "../store/appDispatch.hook"
import { useAppSelector } from "../store/selectors/app.selector"
import { selectedPracticeRoleSelector } from "../store/selectors/selectedPracticeRole.selector"
import { runtimeGetEnabledFeatureFlags } from "../store/thunks/runtime.thunks"

export const useFeatureFlagsPolling = () => {
    const dispatch = useAppDispatch()

    const selectedPracticeRole = useAppSelector(selectedPracticeRoleSelector)

    useEffect(() => {
        if (!selectedPracticeRole?.practice) {
            return
        }

        // Start polling for flag changes every 5 minutes
        const intervalId = setInterval(() => {
            dispatch(
                runtimeGetEnabledFeatureFlags({
                    payload: selectedPracticeRole.practice,
                }),
            )
        }, FEATURE_FLAGS_CONFIG.pollingInterval)

        // Cleanup polling on unmount
        return () => {
            if (intervalId) {
                clearInterval(intervalId)
            }
        }
    }, [dispatch, selectedPracticeRole?.practice.id])
}
